import { combineReducers } from 'redux';
import LoginReducer from '../GlobalModules/Login/Reducers/LoginReducer';
import mainReducerData from './MainReducers';
/* Changes for PM-189 */
import InventoryReducer from './InventoryReducer';
/* Global Branch Controller */
import GlobalBranchReducer from './GlobalBranchReducer';
export default combineReducers({
    LoginReducer,  //login reducer for login related data
    mainReducerData,  //main reducer for application handlers
    InventoryReducer,  //inventory reducer for inventory branch state
    GlobalBranchReducer  //global branch controller (Dashboard as source of truth)
})